import { render, staticRenderFns } from "./basket-icon.vue?vue&type=template&id=0b8eb7ef&scoped=true&functional=true&"
import script from "./basket-icon.vue?vue&type=script&lang=js&"
export * from "./basket-icon.vue?vue&type=script&lang=js&"
import style0 from "./basket-icon.vue?vue&type=style&index=0&id=0b8eb7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0b8eb7ef",
  null
  
)

export default component.exports